export type Rect = {
  x: number;
  y: number;
  top: number;
  bottom: number;
  left: number;
  right: number;
  height: number;
  width: number;
  centerX: number;
  centerY: number;
};

export function withCenter(rect: DOMRect): Rect {
  return {
    x: rect.x,
    y: rect.y,
    top: rect.top,
    bottom: rect.bottom,
    left: rect.left,
    right: rect.right,
    height: rect.height,
    width: rect.width,
    centerX: rect.x + rect.width / 2,
    centerY: rect.y + rect.height / 2,
  };
}
